import { render, staticRenderFns } from "./viewTech.vue?vue&type=template&id=f1751232&scoped=true&"
import script from "./viewTech.vue?vue&type=script&lang=js&"
export * from "./viewTech.vue?vue&type=script&lang=js&"
import style0 from "./viewTech.vue?vue&type=style&index=0&id=f1751232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1751232",
  null
  
)

export default component.exports